import "babel-polyfill";

import * as Modules from './modules';
import { Environment } from './utils/environment';

const env = new Environment();

class Init {
    constructor () {
        this.modules = Modules;
        this.currentModules = [];

        env.$document.on('App:init', () => this.deleteModules().initModules());
    }

    deleteModules () {
        for (let module = this.currentModules.lenght; module--;)
        {
            this.currentModules[module].destroy();
            this.currentModules.splice(module);
        }

        return this;
    }

    initModules () {
        const modules = env.$document.find('[data-module]'); // find data attributes

        for (let moduleEl of Array.from(modules))
        {
            const data = $(moduleEl).data();
            const moduleObj = {
                el: moduleEl,
                $el: $(moduleEl),
                data
            };

            // trim all whitespaces and explode it on the comma
            const multipleModules = moduleObj.data.module.trim().split(',');

            for (const module of multipleModules)
            {
                if (typeof this.modules[module] === 'function')
                {
                    const moduleFn = new this.modules[module](moduleObj);
                    this.currentModules.push(moduleFn);
                }
            }
        }

        return this;
    }
}

{
    const delay = 3000; // add a delay as fallback for when app has not been initialised
    const animateDelay = 600; // add a delay for when animation is done

    // add classes to the body
    const load = () => {
        env.$body.addClass('is-loaded');

        setTimeout(() => {
            env.$body.addClass('is-animated');
        }, animateDelay);
    };

    // init the app
    const init = () => {
        // create App
        window.App = new Init();

        // trigger the app to create the modules
        env.$document.trigger('App:init');

        // execute the load functions
        if (window.matchMedia('(max-width: 1199px)').matches)
        {
            load();
        }
        else if (window.matchMedia('(min-width: 1224px)').matches)
        {
            env.$document.on('SmoothScroll.isReady', () => {
                load();
            });
        }
    };

    // initially flag as not initialised
    let isInitialised = false;

    // init the app after window is loaded
    env.$window.on('load', () => {
        if (!isInitialised)
        {
            init();

            // flag as initialised
            isInitialised = true;
        }
    });

    // if app has not been initialised after delay init it again
    setTimeout(() => {
        if (!isInitialised)
        {
            init();

            // flag as initialised
            isInitialised = true;
        }
    }, delay);
}



// WEBPACK FOOTER //
// ./app/src/js/app.js